import React from 'react';
import { BaseViewportPlugin } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';
import ReferenceLineView from './views/index';
import './plugin.less';
import { ReferenceLineHistory } from './operations/reference-line-history';
import { ReferenceLines } from './reference-lines';
import { useReferenceLinesOperationEvents } from './snap/use-operation-events';
import referenceLinesState from './states/reference-lines-state';

/** 参考线 */
const ReferenceLinesView: React.FC = React.memo(() => {
    useReferenceLinesOperationEvents();
    return (
        <BaseViewportPlugin name="reference-lines">
            <ReferenceLineView />
        </BaseViewportPlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'reference-lines',
    createInstance({ identity }) {
        return [{ key: 'ReferenceLines', value: new ReferenceLines(identity) }];
    },
    createHistory({ identity }) {
        return [new ReferenceLineHistory(identity)];
    },
    createState() {
        return [referenceLinesState];
    },
    render() {
        return <ReferenceLinesView />;
    },
};

export default exportPlugin;
